export function debounce(fn: Function, delay: number, immediate?: boolean) {
	let timer: any = null;
	const debounced = (...params: any[]) => {
		if (timer) {
			clearTimeout(timer);
		}
		if (immediate && !timer) {
			fn.call(null, ...params);
		} else {
			timer = setTimeout(() => {
				timer = null;
				fn.call(null, ...params);
			}, delay);
		}
	};
	debounced.cancel = () => {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
	};
	return debounced;
}

/** A utility function to delay foor a given time in milliseconds, returning a promise */
export const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms));